// extracted by mini-css-extract-plugin
export default {"alert-danger":"rgb(218, 30, 40)","hasError":"styles_hasError__Ua9xQ","addressColumn":"styles_addressColumn__RTamy"};